import { Navigate, type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { ChecklistStepPage } from '../../pages/goods-receiving/register/checklist-step';
import { DocumentStepPage } from '../../pages/goods-receiving/register/document-step';
import { ItemValidationStepPage } from '../../pages/goods-receiving/register/item-validation-step';
import { ItemsStepPage } from '../../pages/goods-receiving/register/items-step';
import { StorageStepPage } from '../../pages/goods-receiving/register/storage-step';
import { SummaryStepPage } from '../../pages/goods-receiving/register/summary-step';
import { SupplierStepPage } from '../../pages/goods-receiving/register/supplier-step';
import { lazyRoute } from '../lazy-route';

// The register/* wizard steps below are deliberately NOT code-split
// (React.lazy/suspended): they are a small, strictly sequential flow always
// exercised together in one session. React Router's data-router navigation
// updates the URL/history entry before a lazily-loaded route's chunk
// resolves; with per-step lazy() + Suspense, that left a window (invisible
// on a fast local box, reliably wide under CI's slower runners) where the
// PREVIOUS step's page — including its own "Indietro" button, which points
// to a DIFFERENT previous step, since every step shares the same label
// (goodsReceiving.wizardBack) — stayed mounted and clickable after the URL
// already showed the new step. That caused a deterministic CI-only E2E
// failure: clicking "Indietro" on the summary step landed on checklist
// instead of storage (see goods-receiving.routes.test.tsx). Keeping these
// eagerly imported means each step mounts synchronously with the route
// change, so the stale-previous-step window cannot exist.

export const goodsReceivingRoutes: RouteObject[] = [
  {
    path: RoutesList.GOODS_RECEIVING,
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="drafts" replace />,
      },
      {
        path: 'history',
        ...lazyRoute(() => import('../../pages/goods-receiving/history-page')),
      },
      {
        path: 'drafts',
        ...lazyRoute(() => import('../../pages/goods-receiving/drafts-page')),
      },
      {
        path: 'register',
        children: [
          { path: 'supplier', element: <SupplierStepPage /> },
          { path: 'document', element: <DocumentStepPage /> },
          { path: 'items', element: <ItemsStepPage /> },
          { path: 'items/:itemId', element: <ItemValidationStepPage /> },
          { path: 'checklist', element: <ChecklistStepPage /> },
          { path: 'storage', element: <StorageStepPage /> },
          { path: 'summary', element: <SummaryStepPage /> },
        ],
      },
    ],
  },
];
